import { DOCTOR_ROOT_PATH, PORTAL_ROOT_PATH } from '@/portal/config';

export const rootPathFor = (role: 'customer' | 'doctor'): string =>
  role === 'doctor' ? DOCTOR_ROOT_PATH : PORTAL_ROOT_PATH;

/** Only allows redirects inside the signed-in role's own portal, so the login page cannot be used as an open redirect. */
export const safeNextPath = (raw: string | null | undefined, role: 'customer' | 'doctor' = 'customer'): string => {
  const root = rootPathFor(role);
  if (!raw) return root;
  if (!raw.startsWith(`${root}/`) && raw !== root) return root;
  if (raw.includes('//') || raw.includes('\\')) return root;
  return raw;
};
